import { Observable } from 'rxjs';

import { get } from '@helpcenter/ajax';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type { UserMention } from './types';

export const fetchUsersJsonWithIssueKey = (
    issueKey: string,
    query: string,
    context: string = contextPath
): Observable<UserMention[]> => {
    const headers = {
        Accept: 'application/json',
    };

    const uri = `${context}/rest/servicedesk/1/customer/mention/${issueKey}/search?q=${query}`;

    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
        get(uri, headers)
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .map(({ response }) => response)
            .catch((e) => {
                return Observable.throw(e);
            })
    );
};
